import React, { Component } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  dateConverter,
  constructUserNameToDisplay,
  isUserHasAccess,
  getLocalizedContent,
} from '../helper'
import { sendShareNotificationEmail } from '../api/request'
import _ from 'lodash'
import { validateCustomMessage } from '../../../server/src/routes/validator'
import TextBox from './TextBox'

class EmailDeliveryStatus extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      resendEmailUserList: [],
      errorMsg: {
        msg: '',
        status: 'success',
      },
      showMessageArea: false,
      resendShareeEmail: '',
      messageToReshare: '',
    }
    this.customMessage = React.createRef()
  }

  componentDidUpdate(prevState) {
    const { errorMsg } = this.state
    if (!_.isEqual(errorMsg, prevState.errorMsg)) {
      if (errorMsg.status !== 'info') {
        setTimeout(
          () => this.setState({ errorMsg: { msg: '', status: 'success' } }),
          7000,
        )
      }
    }
  }

  getMailIdInExistingDeliveryStatus = (
    selectedItemToViewDeliveryStatus,
    id,
  ) => {
    const existingUsers = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus,
    )
    if (existingUsers.includes(id)) {
      return id
    }
    const mailId = id.split('@')
    if (existingUsers.includes(mailId[0])) {
      return mailId[0]
    }
    return ''
  }

  sendEmailToUser = (selectedItemToViewDeliveryStatus, userId) => {
    const { user } = this.props
    if (isUserHasAccess(user, 'Content').hasAccess) {
      this.setState({ showMessageArea: true, resendShareeEmail: userId })
    } else {
      this.setState({ resendShareeEmail: userId }, () => {
        this.resendEmailToUser(selectedItemToViewDeliveryStatus)
      })
    }
  }

  resendEmailToUserCheck = (selectedItemToViewDeliveryStatus) => {
    const { messageToReshare } = this.state
    const errorMsg = validateCustomMessage(messageToReshare)
    if (errorMsg === '') {
      this.clearTextarea()
      this.resendEmailToUser(selectedItemToViewDeliveryStatus)
    } else {
      this.setState({ errorMsg: { msg: errorMsg, status: 'error' } })
      this.customMessage.current.focus()
    }
  }

  resendEmailToUser = async (selectedItemToViewDeliveryStatus) => {
    const { resendShareeEmail, messageToReshare } = this.state
    const recipients = [constructUserNameToDisplay(resendShareeEmail)]
    this.updateResendEmailUserList('add', resendShareeEmail)

    const params = {
      shareType: selectedItemToViewDeliveryStatus.fileType,
      recipients,
      fileName: selectedItemToViewDeliveryStatus.fileName,
      filePath: selectedItemToViewDeliveryStatus.path,
      notificationContent: messageToReshare,
    }

    const sendNotificationResponse = await sendShareNotificationEmail(params)
    if (sendNotificationResponse.status === 200) {
      const deliveryStatusResponse = JSON.parse(sendNotificationResponse.text)
      this.updateDeliveryStatus(
        selectedItemToViewDeliveryStatus,
        deliveryStatusResponse,
      )
      this.updateResendEmailUserList('remove', resendShareeEmail)
    } else {
      this.setStatusMessage(
        getLocalizedContent('deliverystatus.reshare.failed.message'),
        'error',
      )
      this.updateResendEmailUserList('remove', resendShareeEmail)
      this.props.setDeliveryStatus(selectedItemToViewDeliveryStatus)
    }
  }

  updateResendEmailUserList = (type, userId) => {
    const { resendEmailUserList } = this.state
    if (type === 'add') {
      resendEmailUserList.push(userId)
    } else {
      const index = resendEmailUserList.indexOf(userId)
      if (index > -1) {
        resendEmailUserList.splice(index, 1)
      }
    }
    this.setState({ resendEmailUserList })
  }

  updateDeliveryStatus = (
    selectedItemToViewDeliveryStatus,
    deliveryStatusResponse,
  ) => {
    let list = selectedItemToViewDeliveryStatus.shareNotificationStatus
    let failedCount = 0,
      failedUser = []
    deliveryStatusResponse.map((item) => {
      const id = this.getMailIdInExistingDeliveryStatus(
        selectedItemToViewDeliveryStatus,
        item.id,
      )
      if (item.success && id !== '') {
        delete list[id]
        list[id] = {}
        list[id][item.status] = '0'
      }
      if (!item.success) {
        failedCount++
        failedUser.push(item.id)
      }
    })
    if (failedCount === 0) {
      this.setStatusMessage(
        getLocalizedContent('deliverystatus.reshare.success.message'),
        'success',
      )
    } else {
      const errorMessage = _.reduce(
        failedUser,
        function (message, emailId) {
          return `${message} ${emailId},`
        },
        `${getLocalizedContent('deliverystatus.reshare.failed.for.email')}`,
      )
      this.setStatusMessage(errorMessage, 'error')
    }
    selectedItemToViewDeliveryStatus.shareNotificationStatus = list
    this.props.setDeliveryStatus(selectedItemToViewDeliveryStatus)
  }

  setStatusMessage = (msg, status) => {
    this.setState({
      errorMsg: {
        msg,
        status,
      },
    })
  }

  sendLinkToSharePopUp = (selectedItemToViewDeliveryStatus) => {
    this.setState({ resendEmailUserList: [] })
    this.props.shareFileForMoreUser(selectedItemToViewDeliveryStatus)
  }

  clearTextarea = () => {
    this.setState({
      showMessageArea: false,
      resendShareeEmail: '',
      errorMsg: { msg: '', status: 'success' },
      messageToReshare: '',
    })
  }

  handleContentChange = (evt) => {
    const content = evt.target.value
    this.setState({
      messageToReshare: content,
    })
  }

  isContentValid = (content) => {
    const errorMsg = validateCustomMessage(content)
    if (errorMsg !== '') {
      this.setState({ errorMsg: { msg: errorMsg, status: 'error' } })
      this.customMessage.current.focus()
      return false
    }
    return true
  }

  renderDeliveryProperities = () => {
    return (
      <div className="overlay__container">
        <div className="overlay__section">
          <div
            className="overlay__action-close"
            style={{ zIndex: '1' }}
            onClick={() => this.props.closeDeliveryStatusBox()}
          >
            <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-close" />
          </div>
          {this.renderDeliveryStatusDetails()}
        </div>
      </div>
    )
  }

  renderDeliveryStatusDetails = () => {
    const {
      fetchDeliveryStatusInProgress,
      selectedItemToViewDeliveryStatus,
    } = this.props
    return (
      <div className="share__status-holder">
        <div
          className="delivery__status-label tooltip"
          style={{ display: 'flex' }}
        >
          {' '}
          <Message id="deliverystatus.title" />
          {selectedItemToViewDeliveryStatus.fileName.length > 20
            ? ` "${selectedItemToViewDeliveryStatus.fileName.substring(
                0,
                20,
              )}..."`
            : ` "${selectedItemToViewDeliveryStatus.fileName}"`}
          {selectedItemToViewDeliveryStatus.fileName.length > 20 && (
            <span
              className="tooltiptext share__folder-name-tooltip"
              style={{ top: '20px', position: 'absolute', width: '100%' }}
            >
              {selectedItemToViewDeliveryStatus.fileName}
            </span>
          )}
        </div>
        {fetchDeliveryStatusInProgress
          ? this.renderLoader()
          : this.renderStatusOrErrorMessage(selectedItemToViewDeliveryStatus)}
      </div>
    )
  }

  renderLoader = () => {
    return (
      <div className="flexCenter deliverystatus__fetching">
        <div className="deliveryStatus__fetching-label">
          <Message id="deliverystatus.fetch.status" />
        </div>
        {this.renderSpinner()}
      </div>
    )
  }

  renderSpinner = () => {
    return (
      <div className="shareInProgress" style={{ top: '0px' }}>
        <p className="ppvx_loading-spinner deliverStatus__spinner" role="alert">
          <span className="ppvx_loading-spinner__screenreader" />
        </p>
      </div>
    )
  }

  renderResendWithMessage = (selectedItemToViewDeliveryStatus) => {
    const { messageToReshare } = this.state
    return (
      <div className="delivery__status-content">
        <div className="share__user-content-container delivery__status-message">
          <div className="share__user-content-label">
            <Message id="deliverystatus.reshare.message" />
          </div>
          <TextBox
            ref={this.customMessage}
            name="share_message"
            id="share_message"
            className="share__user-content-box text-area"
            placeholder="share.message.input.placeholder"
            maxCharacters="500"
            value={messageToReshare}
            onChangeText={(e) => this.handleContentChange(e)}
            onBlurText={(e) => this.isContentValid(e.target.value)}
            style={{ height: '100%' }}
          />
        </div>
        {this.renderButtons(selectedItemToViewDeliveryStatus)}
      </div>
    )
  }

  renderButtons = (selectedItemToViewDeliveryStatus) => {
    return (
      <div className="share__action-container delivery__status-button">
        <div className="share__action">
          <button
            className="ppvx_btn ppvx_btn--secondary ppvx_btn--size_md flexCenter"
            onClick={() => this.clearTextarea()}
          >
            <span className="uploadButton">
              <Message id="deliverystatus.back" />
            </span>
          </button>
        </div>
        <div className="share__action">
          <button
            className={`ppvx_btn ppvx_btn--size_md flexCenter`}
            onClick={() =>
              this.resendEmailToUserCheck(selectedItemToViewDeliveryStatus)
            }
          >
            <span className="uploadButton">
              <Message id="deliverystatus.reshare.button" />
            </span>
          </button>
        </div>
      </div>
    )
  }

  renderStatusOrErrorMessage = (selectedItemToViewDeliveryStatus) => {
    const { showMessageArea } = this.state
    return (
      <div className="delivery__status-container">
        {this.renderStatusErrorMessage(
          this.checkForErrorMessage(),
          selectedItemToViewDeliveryStatus,
        )}
        {showMessageArea
          ? this.renderResendWithMessage(selectedItemToViewDeliveryStatus)
          : this.renderDeiveryStatusContent(selectedItemToViewDeliveryStatus)}
      </div>
    )
  }

  renderDeiveryStatusContent = (selectedItemToViewDeliveryStatus) => {
    return (
      <div>
        {selectedItemToViewDeliveryStatus.hasOwnProperty(
          'shareNotificationStatus',
        )
          ? this.renderDeliveryStatus(selectedItemToViewDeliveryStatus)
          : this.renderNoDeliveryStatusMessage()}
        {this.renderLinkToSharePopUp(selectedItemToViewDeliveryStatus)}
      </div>
    )
  }

  checkForErrorMessage = () => {
    const { errorMsg } = this.state
    const { deliveryStatusErrorMessage } = this.props
    if (deliveryStatusErrorMessage.msg !== '') {
      return deliveryStatusErrorMessage
    }
    if (errorMsg.msg !== '') {
      return errorMsg
    }
    return { msg: '', status: 'success' }
  }

  renderDeliveryStatus = (selectedItemToViewDeliveryStatus) => {
    const { resendEmailUserList } = this.state
    const showDeliveryNoticationsToUsers = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus,
    )
    return (
      <div className="share__status_container">
        {showDeliveryNoticationsToUsers.length > 0
          ? showDeliveryNoticationsToUsers.map((key, index) => {
              return (
                <div className="share__status-info" key={`${key}_${index}`}>
                  {this.renderShareeName(key)}
                  {this.renderEmailDeliveryStatus(
                    selectedItemToViewDeliveryStatus,
                    key,
                  )}
                  {this.renderEmailFailureAction(
                    selectedItemToViewDeliveryStatus,
                    key,
                    resendEmailUserList,
                  )}
                </div>
              )
            })
          : this.renderNoDeliveryStatusMessage()}
      </div>
    )
  }

  renderNoDeliveryStatusMessage = () => {
    return (
      <div className="share__status_container flexCenter">
        <Message id="deliverystatus.no.data" />
      </div>
    )
  }

  renderStatusErrorMessage = (errorMsg, selectedItemToViewDeliveryStatus) => {
    const { deliveryStatusErrorMessage } = this.props
    return (
      errorMsg.msg !== '' && (
        <div
          className={`ppvx_alert ppvx_alert--type_${errorMsg.status}`}
          role="alert"
        >
          <span>{errorMsg.msg}</span>
          <span>
            {errorMsg.msg === deliveryStatusErrorMessage.msg ? (
              <span>
                <span
                  className="deliveryStatus__retry"
                  onClick={() =>
                    this.props.fetchMetaDataOfFileOrFolder(
                      selectedItemToViewDeliveryStatus,
                    )
                  }
                >
                  <Message id="deliverystatus.retry" />
                </span>
              </span>
            ) : (
              ''
            )}
          </span>
        </div>
      )
    )
  }

  renderShareeName = (userId) => {
    userId = constructUserNameToDisplay(userId)
    return (
      <div
        className="share__status-name ppvx_text--md tooltip"
        onMouseOver={(e) => this.props.onMouseOver(e)}
      >
        {userId.length > 30 ? `${userId.substring(0, 30)}...` : userId}
        {userId.length > 30 && <span className="tooltiptext">{userId}</span>}
      </div>
    )
  }

  renderEmailDeliveryStatus = (selectedItemToViewDeliveryStatus, key) => {
    return (
      <div className="share__status-status ppvx_text--md">
        <div>
          <Message
            id={this.renderEmailStatusLabel(
              selectedItemToViewDeliveryStatus,
              key,
            )}
          />
          {this.isEmailStatusDeliveredOrOpened(
            selectedItemToViewDeliveryStatus,
            key,
          ) &&
            this.renderDeliveryStatusInfoDetails(
              selectedItemToViewDeliveryStatus,
              key,
            )}
        </div>
      </div>
    )
  }

  removeInProgressStatus = (notificationStatus) => {
    const allowed = ['SENT', 'DELIVERED', 'OPENED', 'FAIL_HARD', 'FAIL_SOFT']
    if (notificationStatus.length > 1) {
      return notificationStatus.filter((key) => allowed.includes(key))
    }
    return notificationStatus
  }

  removeFailSoftIfDelivered = (notificationStatus) => {
    const allowed = ['SENT', 'DELIVERED', 'OPENED', 'FAIL_HARD']
    if (
      notificationStatus.length > 1 &&
      _.includes(notificationStatus, 'FAIL_SOFT') &&
      _.includes(notificationStatus, 'DELIVERED')
    ) {
      return notificationStatus.filter((key) => allowed.includes(key))
    }
    return notificationStatus
  }

  removeAlltatusIfFailed = (notificationStatus) => {
    const allowed = ['FAIL_HARD', 'SENT']
    if (
      notificationStatus.length > 1 &&
      _.includes(notificationStatus, 'FAIL_HARD')
    ) {
      return notificationStatus.filter((key) => allowed.includes(key))
    }
    return notificationStatus
  }

  renderDeliveryStatusInfoDetails = (selectedItemToViewDeliveryStatus, key) => {
    const deliveryStatusKeys = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus[key],
    )
    const deliveryStatus = this.removeAlltatusIfFailed(
      this.removeFailSoftIfDelivered(
        this.removeInProgressStatus(deliveryStatusKeys),
      ),
    )

    return (
      <span
        className="ppvx_icon ppvx_icon--size_x1 ppvx_icon-info info__Share tooltip"
        onMouseOver={(e) => this.props.onMouseOver(e)}
      >
        <span className="tooltiptext tooltip_share ppvx_text--sm">
          {deliveryStatus.map((status) => {
            return (
              <div
                className={`tooltip_status_msg ${this.renderEmailStatusForTooltip(
                  status,
                ).toLowerCase()}Status`}
                key={`${status}_${key}`}
              >
                <span className="delivery__status-uppercase">
                  <Message
                    id={`deliverystatus.${this.renderEmailStatusForTooltip(
                      status,
                    ).toLowerCase()}`}
                  />
                  {` - `}
                </span>
                <span>
                  {this.renderDateForStatus(
                    selectedItemToViewDeliveryStatus.shareNotificationStatus[
                      key
                    ][status],
                  )}
                </span>
              </div>
            )
          })}
        </span>
      </span>
    )
  }

  renderEmailFailureAction = (
    selectedItemToViewDeliveryStatus,
    key,
    resendEmailUserList,
  ) => {
    return (
      this.isEmailFailed(selectedItemToViewDeliveryStatus, key) && (
        <div className="share__status-link ppvx_text--md">
          {resendEmailUserList.includes(key)
            ? this.renderSpinnerForShareAgain()
            : this.renderShareAgainLink(selectedItemToViewDeliveryStatus, key)}
        </div>
      )
    )
  }

  renderSpinnerForShareAgain = () => {
    return (
      <p
        style={{ width: '20px', height: '20px' }}
        className="ppvx_loading-spinner"
        role="alert"
      >
        <span className="ppvx_loading-spinner__screenreader" />
      </p>
    )
  }

  renderShareAgainLink = (selectedItemToViewDeliveryStatus, key) => {
    return (
      <span
        className="tooltip ppvx_icon ppvx_icon--size_sm ppvx_icon-share"
        onClick={() =>
          this.sendEmailToUser(selectedItemToViewDeliveryStatus, key)
        }
      >
        <span className="tooltiptext ppvx_text--sm">
          <Message id="deliverystatus.share.again" />
        </span>
      </span>
    )
  }

  isEmailFailed = (selectedItemToViewDeliveryStatus, key) => {
    const status = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus[key],
    )
    return status.includes('FAIL_HARD') || status.includes('FAIL_SOFT')
  }

  renderLinkToSharePopUp = (selectedItemToViewDeliveryStatus) => {
    return (
      <div className="share__more">
        <a
          className="ppvx_link pointer"
          onClick={() =>
            this.sendLinkToSharePopUp(selectedItemToViewDeliveryStatus)
          }
        >
          <span className="ppvx_icon ppvx_icon--size_sm ppvx_icon-add" />
          <Message id="deliverystatus.share.more" />
        </a>
      </div>
    )
  }

  renderEmailStatusLabel = (selectedItemToViewDeliveryStatus, key) => {
    const status = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus[key],
    )
    if (
      status.includes('FAIL_HARD') ||
      (status.includes('FAIL_SOFT') && !status.includes('DELIVERED'))
    ) {
      return 'deliverystatus.failed'
    } else if (status.includes('OPENED')) {
      return 'deliverystatus.read'
    } else if (status.includes('DELIVERED')) {
      return 'deliverystatus.delivered'
    } else if (status.includes('SENT')) {
      return 'deliverystatus.sent'
    } else if (status.includes('IN_PROGRESS')) {
      return 'deliverystatus.inProgress'
    }
    return ''
  }

  renderDateForStatus = (date) => {
    const statusDate = new Date(date)
    return dateConverter(statusDate)
  }

  isEmailStatusDeliveredOrOpened = (selectedItemToViewDeliveryStatus, key) => {
    const status = Object.keys(
      selectedItemToViewDeliveryStatus.shareNotificationStatus[key],
    )
    return status.includes('DELIVERED') || status.includes('OPENED')
  }

  renderEmailStatusForTooltip = (status) => {
    if (status === 'OPENED') {
      return 'READ'
    }
    return status
  }

  render() {
    return <div>{this.renderDeliveryProperities()}</div>
  }
}

export default EmailDeliveryStatus
